import { render, staticRenderFns } from "./av-face-colors.vue?vue&type=template&id=0fa90b25&"
import script from "./av-face-colors.vue?vue&type=script&lang=js&"
export * from "./av-face-colors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports